// Header cart / watch-list count badges. Lifted out of the sprockets carts.js so
// the Stimulus controllers and the (still sprockets) watch_list.js share one copy.
//
// Both badges exist twice in the DOM: once in the desktop header, once in the
// burger menu. The `.count-badge` selectors are the 2026 redesign menu (#15087),
// the `span.fa-shopping-cart-count` / `span.watch-list-count` ones the old menu.

// long enough for the badge-pop animation of the 2026 menu (0.6s)
const POP_DURATION = 600;

function pop(elements) {
  elements.forEach((el) => el.classList.add("changed"));
  setTimeout(() => elements.forEach((el) => el.classList.remove("changed")), POP_DURATION);
}

function setIconState(selector, count) {
  document.querySelectorAll(selector).forEach((icon) => {
    icon.classList.toggle("with-item", count > 0);
  });
}

export function updateCart(count) {
  const badges = [...document.querySelectorAll("span.fa-shopping-cart-count, .shopping-cart-link span.count-badge")];
  badges.forEach((el) => (el.textContent = count));
  pop(badges);
  setIconState(".shopping-cart-link i.fa.fa-shopping-cart", count);
}

export function updateWatchList(count) {
  const badges = [...document.querySelectorAll("span.watch-list-count, .watch-list-link .count-badge > span")];
  // only animate on an actual change - adding to the cart reports the watch count
  // on every response, whether or not the course was on the watch list
  const changed = badges.length > 0 && badges[0].textContent.trim() !== String(count);
  badges.forEach((el) => (el.textContent = count));
  if (changed) pop(badges);
  setIconState(".watch-list-link i", count);
}

// bridge for the sprockets-era watch_list.js, which cannot import from vite.
// Remove together with that file once it is ported to Stimulus.
window.CipBadges = {updateCart, updateWatchList};
